var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-4 mx-2",class:this.expand ? 'grid grid-cols-1 gap-4':'grid grid-cols-3 gap-4'},_vm._l((this.caseData),function(item,indx){return _c('div',{key:_vm.i+indx},[_c('PepCard',{attrs:{"individualData":item,"mainEntity":_vm.mainEntity,"sourceName":_vm.sourceName}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }